import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { FileUploadModalComponent } from './file-upload-modal/file-upload-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})
export class FileUploadComponent implements OnInit {

  @Input() id?: string;
  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  public onCommitFiles = new EventEmitter<File>();
  @Input()
  public formats?: string[];
  public files: File[] = [];
  public rawFiles;
  modal: any;

  constructor(private dialog: MatDialog) { }

  openModal() {
    this.modal = this.dialog.open(FileUploadModalComponent, {
      data: {}
    });
    this.modal.afterClosed().subscribe(result => {
      if(result)
        this.onCommitFiles.emit(result);
      this.modal = null;
    })
  }

  closeMenu() {
    if(this.modal)
      this.modal.close();
    this.modal = null;
  }

  ngOnInit(): void {
    this.formats = this.formats || [];
  }
}
